import {
  CdkDragDrop,
  moveItemInArray,
  transferArrayItem,
  CdkDropListGroup,
  CdkDropList,
  CdkDrag,
} from '@angular/cdk/drag-drop';
import { Component, effect, input, output, ChangeDetectionStrategy } from '@angular/core';
import deepmerge from 'deepmerge';
import { DraggableElements, DraggableListConfiguration, ElementDroppedEvent } from './drag-and-drop-lists.model';
import { NgClass, UpperCasePipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'miq-drag-and-drop-lists',
  templateUrl: './drag-and-drop-lists.component.html',
  styleUrl: './drag-and-drop-lists.component.scss',
  imports: [CdkDropListGroup, CdkDropList, NgClass, CdkDrag, MatIcon, UpperCasePipe],
})
export class DragAndDropListsComponent {
  /** Array of draggable lists to render */
  readonly draggableLists = input<DraggableListConfiguration[]>();
  /** Emits when user picks and drops any element */
  readonly elementDropped = output<ElementDroppedEvent>();
  _draggableLists: DraggableListConfiguration[];

  constructor() {
    effect(() => {
      const lists = this.draggableLists();
      if (lists != null) {
        this._draggableLists = deepmerge([], lists);
        this.runSortingFunctions();
      }
    });
  }

  /**
   * Applies logic to move dragged element in the same list or to another list.
   * It also sorts the elements using custom configuration
   */
  onElementDrop(event: CdkDragDrop<DraggableElements[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
    }
    this.runSortingFunctions();
    this.elementDropped.emit(this.generateDroppedEvent());
  }

  private runSortingFunctions(): void {
    this._draggableLists.forEach(list => {
      const { sorting = null, elements = null } = list || {};
      if (sorting != null && sorting.fn != null) {
        list.elements = sorting.fn(elements);
      }
    });
  }

  private generateDroppedEvent(): ElementDroppedEvent {
    return this._draggableLists.reduce((acc, { id, elements }) => ({ ...acc, [id]: elements }), {});
  }
}
